// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Local Imports
import instance from "../../store/axios";
import { LOADING } from "../../store/actions";

class TakeSubscriptionActionService {
  private navigate = useNavigate();
  private dispatch = useDispatch();

  public async getSubscriptionDetailsData(
    subscriptionId: string | undefined
  ): Promise<any[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{
        data: any[];
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/subscription/review/${subscriptionId}`);
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/subscription/take-action/${subscriptionId}`
      );
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async takeAction(
    subscriptionId: string | undefined,
    action: string,
    value: string
  ): Promise<string | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    this.dispatch({ type: LOADING, payload: true });
    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/subscription/${subscriptionId}/review`, {
        approved: action === "approve" ? true : false,
        [action === "approve" ? "subTransactionId" : "statusReason"]: value,
      });
      action === "approve"
        ? toast.success("Subscription approved successfully")
        : toast.success("Subscription rejected successfully");
      return "success";
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/subscription/take-action/${subscriptionId}`
      );
    }
    this.dispatch({ type: LOADING, payload: false });
  }
}

export default TakeSubscriptionActionService;
